/** Completed tool output only; partial arguments and unrelated tools never reach the resolver. */
export type VoiceProposal =
  | { callId: string; tool: 'propose_clearance' | 'pilot_query'; args: unknown }
  | { callId: string; tool: 'request_repeat'; spokenCallsign?: string };

export function readVoiceProposal(event: unknown): VoiceProposal | null {
  if (!event || typeof event !== 'object') return null;
  const e = event as { type?: string; response?: { status?: string; output?: { type?: string; name?: string; call_id?: string; arguments?: string }[] } };
  if (e.type !== 'response.done' || e.response?.status !== 'completed' || !Array.isArray(e.response.output)) return null;
  const calls = e.response.output.filter((o) => o && typeof o === 'object' && o.type === 'function_call');
  if (calls.length !== 1) return null;
  const tool = calls[0]!;
  if (typeof tool.call_id !== 'string' || !tool.call_id || typeof tool.arguments !== 'string' || tool.arguments.length > 8192) return null;
  let args: unknown;
  try { args = JSON.parse(tool.arguments); } catch { return null; }
  if (!args || typeof args !== 'object' || Array.isArray(args)) return null;
  if (tool.name === 'propose_clearance' || tool.name === 'pilot_query') return { callId: tool.call_id, tool: tool.name, args };
  if (tool.name === 'request_repeat') {
    const heard = (args as { spokenCallsign?: unknown }).spokenCallsign;
    return { callId: tool.call_id, tool: 'request_repeat', ...(typeof heard === 'string' && heard.length <= 80 ? { spokenCallsign: heard } : {}) };
  }
  return null;
}
